import React from 'react';
import {Databox,LoadGraphic,Step} from '../components-static/Common';
import PublicPageLayout from '../components-app/PublicPageLayout';
import {Box,Button,Checkbox} from '../components-static/Input';
import sha from 'sha1';
import u from '../utilities/Utilities';
import {Link} from 'react-router-dom';
import qs from 'query-string';
import '../styles/create-user.scss';
import '../styles/login.scss';

export default class CreateUser extends React.Component{

    state={
        loading:false,
        loadText: "Creating account...",
        step:0,
        entryData:{},
        error:"",
        privacypolicy:false,
    };

    componentDidMount=()=>{
        const query = qs.parse(this.props.location.search);
        const passToken = query.token;

        if(typeof passToken == "undefined") {
            this.setState({error:"Error! Please access this page from the link sent to your email"});
        }

        this.setState({instantiated:true,passToken:passToken});
    }

    onCreateUser=()=>{
        const input = ["email","password","passconf"];
        const entryData = this.state.entryData;

        for(var i=0; i<input.length; i++){
            const current = this.refs[input[i]].validate();
            if(!current.valid){
                this.setState({error:current.value});
                return 0;
            }
        }

        if(entryData.password != entryData.passconf){
            this.setState({error:"Passwords do not match"});
            return 0;
        }

        if(!this.state.privacypolicy){
            this.setState({error:"Please agree to our Privacy Policy and Cookie Use Policy to continue"});
            return 0;
        }

        this.setState({loading:true,error:""});

        u.post({
            url:"/noauth/create-user",
            data:{
                email:entryData.email,
                password:sha(entryData.password),
                token:this.state.passToken
            },
            success:(callback)=>{
                this.setState({step:1,loading:false});
            },
            error:(error,status)=>{
                this.setState({error:error,loading:false});
            }
        })
    }

    onChange=(value,label,index)=>{
        let entryData = this.state.entryData;
        entryData[label]=value;
        this.setState({entryData:entryData});
    }

    render(){
        const enabled=(typeof this.state.passToken != "undefined");
        const entryData = this.state.entryData;

        return(
            <PublicPageLayout title="Create User" url="/create-user">
                <div style={{position:"relative",textAlign:"center"}}>
                    <div className="login-container">
                        <div className="login-message-container">
                            <h2 className="login-message">Create Account</h2>
                        </div>

                        <div className="page-error">{this.state.error}</div>

                        <Step active={(this.state.step == 0)}>
                            <div>
                                <div style={{position:"relative"}}>
                                    <LoadGraphic active={this.state.loading} text={this.state.loadText}/>

                                    <form className="login-form" onSubmit={this.onCreateUser} style={{margin:"20px auto"}}>
                                        <div className="input-item">
                                            <div className="input-label">Email:</div>
                                            <Box ref="email" label="Email" field="email" values={{value:entryData.email,enabled:enabled}} rules={{required:true}} type="email" onChange={this.onChange}/>
                                        </div>
                                        <div className="input-item">
                                            <div className="input-label">Password:</div>
                                            <Box ref="password" label="Password" field="password" type="password" values={{value:entryData.password,enabled:enabled}} rules={{required:true,minLength:8}} onChange={this.onChange}/>
                                        </div>
                                        <div className="input-item">
                                            <div className="input-label">Confirm Password:</div>
                                            <Box ref="passconf" label="Confirm Password" field="passconf" type="password" values={{value:entryData.passconf,enabled:enabled}} rules={{required:true}} onChange={this.onChange}/>
                                        </div>
                                        <div className="input-item">
                                            <div className="privacy-checkbox">
                                                <Checkbox style={{margin:0}} values={{value:this.state.privacypolicy}} onChange={(value)=>{this.setState({privacypolicy:value})}}/>
                                            </div>
                                            <div className="privacy-label">By clicking on Create Account, you have read and agree to our <a href="https://kallang164.vitapartners.com/privacy-policy" target="_blank">Privacy Policy</a></div>
                                        </div>
                                    </form>

                                    <Button onClick={this.onCreateUser} type="medium" enabled={enabled}>Create Account</Button>
                                </div>
                            </div>
                        </Step>

                        <Step active={(this.state.step == 1)}>
                            <div style={{padding:"20px 0"}}>
                                <h2>
                                    <img src="/images/input/confirm.png" style={{height:"60px",display:"inline-block",verticalAlign:"middle",margin:"0 20px"}}/>
                                    <span style={{display:"inline-block",verticalAlign:"middle",margin:"20px auto 5px auto"}}>Account has been successfully created</span>
                                </h2>
                                <div className="disclaimer-text" style={{margin:"0 auto 20px auto"}}>
                                    Portal admin login <Link to="/login" title="Login here">here</Link>
                                </div>
                            </div>
                        </Step>
                    </div>

                    <div className="disclaimer">
                        <div className="disclaimer-text">
                            Access your building's turnstiles by downloading the app below
                        </div>
                        <div className="disclaimer-buttons">
                            <img src="/images/app/appstore-badge.png" className="badge" onClick={()=>{u.onAppStore()}}/>
                            <img src="/images/app/play-badge.png" className="badge" onClick={()=>{u.onPlayStore()}}/>
                        </div>
                    </div>
                </div>
            </PublicPageLayout>
        )
    }
}
